import { DefaultComponent, OptionsWithoutResolver } from '@loadable/component'
import { IDelayOptions, loadableComponent } from './loadableComponent'

const DEFAULT_PAGE_OPTIONS = {
  delay: 250,
}

/**
 * Creates an async import with some defaults
 * @see https://loadable-components.com/docs/code-splitting/
 * @note Imported module must have a default export
 * @example
 * ```
 * const DashboardPageAsync = loadablePage(() => import('./DashboardPage'), {
 *   fallback: <span>Loading...</span>,
 *   delay: 250
 * })
 * ```
 */
export function loadablePage<Props>(
  loadFn: (props: Props) => Promise<DefaultComponent<Props>>,
  options?: OptionsWithoutResolver<Props> & IDelayOptions
) {
  return loadableComponent(loadFn, { ...DEFAULT_PAGE_OPTIONS, ...options })
}
